'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _defaults = require('lodash/defaults');

var _defaults2 = _interopRequireDefault(_defaults);

var _detectNode = require('detect-node');

var _detectNode2 = _interopRequireDefault(_detectNode);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _methods = require('./methods');

var _methods2 = _interopRequireDefault(_methods);

var _utils = require('../utils');

var _transports = require('./transports');

var _transports2 = _interopRequireDefault(_transports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debugEmitters = (0, _debug2.default)('golos:emitters');
var debugSetup = (0, _debug2.default)('golos:setup');

var DEFAULTS = {
  id: 0
};

var Golos = function (_EventEmitter) {
  _inherits(Golos, _EventEmitter);

  function Golos() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Golos);

    var _this = _possibleConstructorReturn(this, (Golos.__proto__ || Object.getPrototypeOf(Golos)).call(this, options));

    (0, _defaults2.default)(options, DEFAULTS);
    _this.options = (0, _cloneDeep2.default)(options);
    _this._streamDefaults = {
      mode: 'head',
      startBlock: 0
    };
    return _this;
  }

  _createClass(Golos, [{
    key: '_setTransport',
    value: function _setTransport(url) {
      if (url && url.match('^((http|https)?:\/\/)')) {
        this.transport = new _transports2.default.http();
        this.url = url;
      } else if (url && url.match('^((ws|wss)?:\/\/)')) {
        this.transport = new _transports2.default.ws();
        this.url = url;
      } else {
        throw Error("unknown transport! [" + url + "]");
      }
    }
  }, {
    key: 'setWebSocket',
    value: function setWebSocket(url) {
      console.warn("golos.api.setWebSocket(url) is now deprecated instead use golos.config.set('websocket',url)");
      debugSetup('Setting WS', url);
      _config2.default.set('websocket', url);
      this._setTransport(url);
      this.stop();
    }
  }, {
    key: 'start',
    value: function start() {
      var url = _config2.default.get('websocket');
      this._setTransport(url);
      return this.transport.start();
    }
  }, {
    key: 'stop',
    value: function stop() {
      debugSetup('Stopping...');
      var ret = this.transport.stop();
      this.transport = null;
      this.url = null;
      return ret;
    }
  }, {
    key: 'send',
    value: function send(api, data, callback) {
      debugSetup('Golos::send', api, data);
      if (!this.transport) {
        this.start();
      } else {
        var url = _config2.default.get('websocket');
        if (url !== this.url) {
          debugSetup('websocket URL changed, restarting transport...');
          this.stop();
          this.start();
        }
      }
      return this.transport.send(api, data, callback);
    }
  }, {
    key: 'callReliable',
    value: function callReliable(method) {
      var _this2 = this;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var callback = args[args.length - 1];
      var argsWithoutCb = args.slice(0, args.length - 1);
      this[method].apply(this, _toConsumableArray(argsWithoutCb).concat([function (err, result) {
        if (err || !result) {
          console.error(method + ' reliable call - fail, retrying... Cause:', err ? err.message : 'API returned null');
          _bluebird2.default.delay(1000).then(function () {
            _this2.callReliable.apply(_this2, [method].concat(args));
          });
          return;
        }
        callback(null, result);
      }]));
    }
  }, {
    key: 'streamBlockNumber',
    value: function streamBlockNumber(options, callback) {
      var _this3 = this;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      (0, _defaults2.default)(options, this._streamDefaults);
      var startBlock = options.startBlock;
      var prevBlock = 0;
      var running = true;

      var update = function update() {
        if (!running) return;

        _this3.callReliableAsync('getDynamicGlobalProperties').then(function (result) {
          var currentBlock = options.mode === 'irreversible' ? result.last_irreversible_block_num : result.head_block_number;

          if (!startBlock) startBlock = currentBlock;

          for (var i = startBlock; i <= currentBlock; i++) {
            callback(null, i);
          }
          startBlock = currentBlock + 1;

          _bluebird2.default.delay(1000).then(function () {
            update();
          });
        }, function (err) {
          callback(err);
        });
      };

      update();

      return function () {
        running = false;
      };
    }
  }, {
    key: 'streamBlock',
    value: function streamBlock(options, callback) {
      var _this4 = this;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      (0, _defaults2.default)(options, this._streamDefaults);

      var current = '';
      var last = '';

      var release = this.streamBlockNumber(options, function (err, id) {
        if (err) {
          release();
          callback(err);
          return;
        }

        current = id;
        if (current !== last) {
          last = current;
          _this4.callReliable('getBlock', current, function (err, res) {
            res.block_num = current;
            res.timestamp_prev = new Date(new Date(res.timestamp).getTime() - 3000).toISOString().split('.')[0];
            callback(err, res);
          });
        }
      });

      return release;
    }
  }, {
    key: 'streamTransactions',
    value: function streamTransactions(options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      (0, _defaults2.default)(options, this._streamDefaults);

      var release = this.streamBlock(options, function (err, block) {
        if (err) {
          release();
          callback(err);
          return;
        }

        if (block && block.transactions) {
          block.transactions.forEach(function (transaction) {
            callback(null, transaction, block);
          });
        }
      });

      return release;
    }
  }, {
    key: 'streamOperations',
    value: function streamOperations() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      (0, _defaults2.default)(options, this._streamDefaults);

      var release = this.streamTransactions(options, function (err, transaction, block) {
        if (err) {
          release();
          callback(err);
          return;
        }

        transaction.operations.forEach(function (operation) {
          callback(null, operation, transaction, block);
        });
      });

      return release;
    }
  }]);

  return Golos;
}(_events2.default);

// Generate Methods from methods.js


_methods2.default.forEach(function (method) {
  var methodName = method.method_name || (0, _utils.camelCase)(method.method);
  var methodParams = method.params || [];
  var defaultParms = {};
  var hasDefaultValues = method.has_default_values;

  if (hasDefaultValues) {
    methodParams.forEach(function (param) {
      var _param$split = param.split('='),
          _param$split2 = _slicedToArray(_param$split, 2),
          p = _param$split2[0],
          value = _param$split2[1];

      defaultParms[p] = value ? JSON.parse(value) : '';
    });
  }

  Golos.prototype[methodName + 'With'] = function Golos$$specializedSendWith(options, callback) {
    var params = methodParams.map(function (param) {
      return options[hasDefaultValues ? param.split('=')[0] : param];
    });
    return this.send(method.api, {
      method: method.method,
      params: params
    }, callback);
  };

  Golos.prototype[methodName] = function Golos$specializedSend() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var options = {};
    if (hasDefaultValues) {
      var argsWithoutCb = args.slice(0, args.length - 1);
      methodParams.forEach(function (param, i) {
        var _param$split3 = param.split('='),
            _param$split4 = _slicedToArray(_param$split3, 2),
            p = _param$split4[0],
            value = _param$split4[1];

        if (argsWithoutCb[i]) {
          options[p] = argsWithoutCb[i];
        }
      });
      options = Object.assign({}, defaultParms, options);
    } else {
      var opt = methodParams.reduce(function (memo, param, i) {
        memo[param] = args[i];
        return memo;
      }, {});
      options = Object.assign({}, opt);
    }
    var callback = args[hasDefaultValues ? args.length - 1 : methodParams.length];

    return this[methodName + 'With'](options, callback);
  };
});

_bluebird2.default.promisifyAll(Golos.prototype);

Golos.prototype['setBlockAppliedCallback'] = function Golos$setCallback(type, callback) {
  return this.send('database_api', {
    method: 'set_block_applied_callback',
    params: [type]
  }, callback);
};

Golos.prototype['setPendingTransactionCallback'] = function Golos$setCallback(callback) {
  return this.send('database_api', {
    method: 'set_pending_transaction_callback',
    params: []
  }, callback);
};

Golos.prototype['setPrivateMessageCallback'] = function Golos$setCallback(query, callback) {
  return this.send('private_message', {
    method: 'set_callback',
    params: [query]
  }, callback);
};

// Export singleton instance
var golos = new Golos();
exports = module.exports = golos;
exports.Golos = Golos;
exports.Golos.DEFAULTS = DEFAULTS;